import { vars } from "./contract.css";

export const pxToUnit = (px: number, unit: "rem" | "em") => `${px / 16}${unit}`;

export const darken = (color: string, amount = 20) =>
  `color-mix(in srgb, ${color} ${100 - amount}%, black)`;

export const lighten = (color: string, amount = 20) =>
  `color-mix(in srgb, ${color} ${100 - amount}%, white)`;

export const tint = (color: string, opacity = 20) =>
  `color-mix(in srgb, ${color} ${opacity}%, transparent)`;

export const focusRing = (color: string, opacity = 20) =>
  `0 0 0 2px ${tint(color, opacity)}`;

export const emphasize = (color: string, amount = 20) =>
  `color-mix(in srgb, ${color} ${100 - amount}%, ${vars.color.text})`;
